import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { X5BankPhoneInput as Component } from './phone-input';
import type { IPropsX5BankPhoneInput } from './models';

export const X5BankPhoneInput = createWidget<unknown, IPropsX5BankPhoneInput>({})(Component);
